import React from 'react';
import { InputNumber } from 'primereact/inputnumber';

const ItemNumberInput = ({ value, onChange }) => {
  return (
    <div className="likkan-stepper">
      <button
        type="button"
        className="p-button p-button-sm p-button-danger likkan-stepper-btn justify-content-center"
        onClick={() => onChange(Math.max(0, (value || 0) - 1))}
      >
        −
      </button>
      <InputNumber
        value={value || 0}
        onValueChange={(e) => onChange(e.value ?? 0)}
        showButtons={false}
        inputClassName="likkan-stepper-input"
        min={0}
      />
      <button
        type="button"
        className="p-button p-button-sm p-button-success likkan-stepper-btn justify-content-center"
        onClick={() => onChange((value || 0) + 1)}
      >
        ＋
      </button>
    </div>
  );
};

export default ItemNumberInput;
